'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _PasswordResetRequest = require('./PasswordResetRequest');

var _PasswordResetRequest2 = _interopRequireDefault(_PasswordResetRequest);

var _EmailConfirmation = require('./EmailConfirmation');

var _EmailConfirmation2 = _interopRequireDefault(_EmailConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PasswordResetRequestPage = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(PasswordResetRequestPage, _Component);

  function PasswordResetRequestPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PasswordResetRequestPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordResetRequestPage.__proto__ || Object.getPrototypeOf(PasswordResetRequestPage)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'displayEmailConfirmation', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PasswordResetRequestPage, [{
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var email = event.email,
          SessionStore = this.props.SessionStore;


      SessionStore.requestPasswordReset(email);
      this.displayEmailConfirmation = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true, className: 'page-login' },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            {
              lgOffset: 3, lg: 6,
              mdOffset: 3, md: 6,
              smOffset: 3, sm: 6,
              xsOffset: 1, xs: 10,
              className: 'wrapper-login'
            },
            this.displayEmailConfirmation === false ? _react2.default.createElement(_PasswordResetRequest2.default, { handleSubmit: this.handleSubmit }) : _react2.default.createElement(_EmailConfirmation2.default, null)
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PasswordResetRequestPage;
}(_react.Component), _class3.propTypes = {
  SessionStore: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'displayEmailConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = PasswordResetRequestPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PasswordResetRequestPage, 'PasswordResetRequestPage', '/app/src/components/page-password-reset/PasswordResetRequestPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-password-reset/PasswordResetRequestPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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